var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.21 7.81994L12.51 12.2799C12.2 12.4599 11.81 12.4599 11.49 12.2799L3.78997 7.81994C3.23997 7.49994 3.09997 6.74994 3.51997 6.27994C3.80997 5.94994 4.13997 5.67994 4.48997 5.48994L9.90997 2.48994C11.07 1.83994 12.95 1.83994 14.11 2.48994L19.53 5.48994C19.88 5.67994 20.21 5.95994 20.5 6.27994C20.9 6.74994 20.76 7.49994 20.21 7.81994Z",
    fill: "#797979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 14.14V20.96C11.43 21.72 10.66 22.22 9.97998 21.89C7.91998 20.88 4.44998 18.99 4.44998 18.99C3.22998 18.3 2.22998 16.56 2.22998 15.13V9.97C2.22998 9.18 3.05998 8.68 3.73998 9.07L10.93 13.24C11.23 13.43 11.43 13.77 11.43 14.14Z",
    fill: "#797979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5701 14.14V20.96C12.5701 21.72 13.3401 22.22 14.0201 21.89C16.0801 20.88 19.5501 18.99 19.5501 18.99C20.7701 18.3 21.7701 16.56 21.7701 15.13V9.97C21.7701 9.18 20.9401 8.68 20.2601 9.07L13.0701 13.24C12.7701 13.43 12.5701 13.77 12.5701 14.14Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.871e3cfbacd4f5ac93e342584a3dd10c.svg";
export { ForwardRef as ReactComponent };